const inkeep_ai_bot = {
    intro_message: '你好，我是Logto人工智慧！\n\n 我是訓練於文檔、幫助文章以及其他內容的人工智慧助手。\n\n 你可以問我任何關於Logto的問題。',
    chat_placeholder: '向Logto人工智慧詢問你的問題以獲得逐步指南',
    disclaimer_label: 'Logto人工智慧免責聲明',
    disclaimer_tooltip: '回覆內容由人工智慧生成，可能需要進一步核實。',
    example_questions_label: '示例問題',
    example_questions: ['Logto 設置的快速指南', '配置多租戶架構', '如何整合用戶資料？'],
    stop: '停止',
    clear: '重新開始',
    get_help: '獲得幫助',
    copy_chat: '複製',
    ask_ai_label: '詢問人工智慧',
    contact: '聯絡我們',
    discord: 'Discord社群',
};
export default Object.freeze(inkeep_ai_bot);
